import { Fetch } from '../shared/general';

//#region ======== ACTIONS ========
const actions = {
    //======== CLAIM MANAGEMENT ======
    shift_shift_create      : "shift_shift_create",
    shift_list_get          : "shift_list_get",
    shift_id_get            : "shift_id_get",
    shift_shift_update      : "shift_shift_update",
};
//#endregion


//#region ========== API FUNCTIONS ===========
export function shift_shift_create(data){
    return Fetch({ action: actions.shift_shift_create, data: data });
}

export function shift_list_get(data){
    return Fetch({ action: actions.shift_list_get, data: data });
}

export function shift_id_get(data){
    return Fetch({ action: actions.shift_id_get, data: data });
}

export function shift_shift_update(data){
    return Fetch({ action: actions.shift_shift_update, data: data });
}

// export function branch_branch_remove(data){
//     return Fetch({ action: actions.branch_branch_remove, data: data });
// }